import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAntiSpatterSpraySm = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 100 100",
	...props,
	children: [
		/* @__PURE__ */ _jsx("title", { children: "anti-spatter-spray-sm" }),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-white",
			d: "M92.15,57.6a.5.5,0,0,0,0-.17h0l-.06-.15,0,0a.86.86,0,0,0-.07-.1l0,0L91.8,57,67.41,42.91V37.55a.73.73,0,0,0-.36-.63L50.26,27.35a.71.71,0,0,0-.72,0L33,36.92a.73.73,0,0,0-.36.63v5.21L8.2,56.85l-.13.1,0,0a.86.86,0,0,0-.07.1l0,0-.06.15h0a.5.5,0,0,0,0,.17v4.34a.71.71,0,0,0,.36.62l41.57,24h0a.33.33,0,0,0,.12,0l0,0,.17,0,.17,0,0,0,.12,0h0L91.8,62.56a.72.72,0,0,0,.36-.62V57.6Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-outline",
			d: "M92.63,57.56a1.1,1.1,0,0,0,0-.18l0-.08a1,1,0,0,0-.1-.25l0-.06a.86.86,0,0,0-.13-.17l-.07-.08a1.41,1.41,0,0,0-.21-.16L67.88,42.64V37.55a1.18,1.18,0,0,0-.59-1L50.5,26.94a1.22,1.22,0,0,0-1.21,0L32.72,36.51a1.17,1.17,0,0,0-.6,1v4.94L8,56.43a1,1,0,0,0-.26.19l-.06.07a.71.71,0,0,0-.1.14l-.06.08a1.57,1.57,0,0,0-.09.23l0,.09a1.11,1.11,0,0,0,0,.17v4.39a1.21,1.21,0,0,0,.6,1l41.55,24,.07,0a.93.93,0,0,0,.2.08l0,0a1,1,0,0,0,.3,0,.87.87,0,0,0,.31,0h.05l.19-.08L92,63a1.19,1.19,0,0,0,.61-1Zm-43.7,24.6v1.55L9.76,61.1V59.55ZM51.2,64.25V47.88l14.28-8.25V56ZM50,45.8,35.72,37.55l14.17-8.19,14.29,8.25ZM32.72,57.74l1,.54V55.15h.85V39.63L48.8,47.88V64.25l-10-5.79v2.77L49.4,67.37a1.22,1.22,0,0,0,1.2,0l16.68-9.63a1.19,1.19,0,0,0,.6-1.05V45.41L89,57.62,50.13,80.08,11,57.47,32.12,45.26V56.69A1.19,1.19,0,0,0,32.72,57.74Zm57.52,2v1.55L51.33,83.71V82.16Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m33.6 55.8 16.4 9.5 16.7-9.6",
			fill: "none",
			stroke: "var(--icon-highlight)",
			strokeWidth: 2.4,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M68 17.6 45.4 29.8M68 20.7 45.4 41.8M69.5 23.6 53.8 51.2",
			fill: "none",
			stroke: "var(--icon-highlight)",
			strokeWidth: 2.4,
			strokeLinecap: "round",
			strokeDasharray: "3.2 4"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-white",
			d: "M75 22c0-4 15-4 15 0v23c0 4-15 4-15 0Z",
			stroke: "var(--icon-outline)",
			strokeWidth: 2.4,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M75 22c0 4 15 4 15 0",
			fill: "none",
			stroke: "var(--icon-outline)",
			strokeWidth: 2.4
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-white",
			d: "M77 18v-5h7v5",
			stroke: "var(--icon-outline)",
			strokeWidth: 2.4,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-white",
			d: "M70.6 13H77v4.5h-6.4Z",
			stroke: "var(--icon-outline)",
			strokeWidth: 2.4,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "icon-highlight",
			x: 78.4,
			y: 32.3,
			width: 8.2,
			height: 2.4,
			rx: 1.2
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "icon-highlight",
			cx: 70.6,
			cy: 15.3,
			r: 1.2
		})
	]
});
export default SvgAntiSpatterSpraySm;
